document.addEventListener('DOMContentLoaded', function () {
    const nav = document.querySelector('.site-header__nav');

    if (!nav) {
        return;
    }

    const mask = document.querySelector('.site-header__mask');
    const menuToggles = document.querySelectorAll('.site-header__menu-toggle');
    const menuLinks = document.querySelectorAll('.site-header__link');
    const body = document.body;

    if (!menuToggles.length) {
        return;
    }

    function openMenu() {
        nav.classList.add('show');

        if (mask) {
            mask.classList.add('show');
        }

        menuToggles.forEach((toggle) => {
            toggle.setAttribute('aria-expanded', 'true');
        });
        body.classList.add('overflow-hidden');
    }

    function closeMenu() {
        nav.classList.remove('show');

        if (mask) {
            mask.classList.remove('show');
        }

        menuToggles.forEach((toggle) => {
            toggle.setAttribute('aria-expanded', 'false');
        });

        body.classList.remove('overflow-hidden');
    }

    menuToggles.forEach((menuToggle) => {
        menuToggle.addEventListener('click', function () {
            if (nav.classList.contains('show')) {
                closeMenu();
            } else {
                openMenu();
            }
        });
    });

    // Menu toggle fixo
    const fixedMenuToggle = document.querySelector('.site-header__menu-toggle.fixed');

    if (fixedMenuToggle) {
        function handleScroll() {
            fixedMenuToggle.classList.toggle('show', window.scrollY >= 100);
        }

        window.addEventListener('scroll', handleScroll);
        handleScroll();
    }

    if (mask) {
        mask.addEventListener('click', function () {
            closeMenu();
        });
    }
    menuLinks.forEach((link) => {
        link.addEventListener('click', function () {
            closeMenu();
        });
    });
});